export default {
  app: {
    name: 'NomadMate',
  },
  notFound: {
    title: 'Strona nie znaleziona',
    description: 'Strona, której szukasz, nie istnieje',
    goBack: 'Wróć na stronę główną',
  },
  common: {
    loading: 'Ładowanie...',
    noData: 'Brak danych',
    error: 'Wystąpił błąd, spróbuj ponownie',
    retry: 'Ponów',
    authExpired: 'Sesja wygasła, zaloguj się ponownie',
    requestFailed: 'Żądanie nie powiodło się',
    networkError: 'Błąd sieci, sprawdź połączenie',
    skipToContent: 'Przejdź do treści głównej',
  },
  nav: {
    dashboard: 'Panel',
    visa: 'Wiza',
    cost: 'Koszty',
    timezone: 'Strefa czasowa',
    tax: 'Podatki',
    guide: 'Przewodnik',
    login: 'Zaloguj',
  },
  footer: {
    about: 'O nas',
    privacy: 'Prywatność',
    terms: 'Regulamin',
    copyright: '© 2026 NomadMate',
  },
  index: {
    hero: {
      title: 'Twoje życie cyfrowego nomady, zorganizowane',
      subtitle: 'Wszystko w jednym: śledzenie wiz, porównanie kosztów, koordynacja stref czasowych, zgodność podatkowa i przewodniki miejskie',
      cta: 'Zacznij za darmo',
      learnMore: 'Dowiedz się więcej',
    },
    features: {
      title: 'Funkcje',
      visa: { title: 'Śledzenie wiz', desc: 'Śledź typy wiz, ważność i przypomnienia o przedłużeniu' },
      cost: { title: 'Porównanie kosztów', desc: 'Porównuj koszty życia: zakwaterowanie, jedzenie, transport i więcej' },
      timezone: { title: 'Zarządzanie czasem', desc: 'Zegary wielu stref i koordynacja spotkań między strefami czasowymi' },
      tax: { title: 'Asystent podatkowy', desc: 'Wyszukiwanie transgranicznych przepisów podatkowych i alerty dni pobytu' },
      guide: { title: 'Przewodnik miast', desc: 'Szczegółowe przewodniki po światowych destynacjach dla cyfrowych nomadów' },
    },
    stats: {
      countries: 'Kraje',
      cities: 'Miasta',
      languages: 'Języki',
    },
  },
  login: {
    login: 'Zaloguj się',
    register: 'Zarejestruj się',
    subtitle: 'Zaloguj się do NomadMate i zarządzaj życiem nomady',
    registerSubtitle: 'Utwórz konto i rozpocznij życie cyfrowego nomady',
    email: 'E-mail',
    emailPlaceholder: 'twoj@email.com',
    emailInvalid: 'Wprowadź prawidłowy adres e-mail',
    username: 'Nazwa użytkownika',
    usernamePlaceholder: 'Wprowadź nazwę użytkownika',
    password: 'Hasło',
    passwordPlaceholder: '••••••••',
    passwordTooShort: 'Hasło musi mieć co najmniej 6 znaków',
    confirmPassword: 'Potwierdź hasło',
    confirmPasswordPlaceholder: 'Wprowadź hasło ponownie',
    passwordMismatch: 'Hasła nie są zgodne',
    loading: 'Logowanie...',
    error: 'Logowanie nie powiodło się, spróbuj ponownie',
    orContinueWith: 'Lub kontynuuj przez',
    noAccount: 'Nie masz konta?',
    hasAccount: 'Masz już konto?',
  },
  dashboard: {
    welcome: 'Witaj ponownie, {name}',
    subtitle: 'Przegląd Twojego życia nomady',
    stats: {
      activeVisas: 'Aktywne wizy',
      daysUntilExpiry: 'Dni do wygaśnięcia',
      citiesCompared: 'Porównane miasta',
      timezones: 'Śledzone strefy',
    },
    expiryAlerts: 'Alerty wygaśnięcia wiz',
    noAlerts: 'Brak alertów o wygaśnięciu',
    daysLeft: '{days} dni pozostało',
    worldClocks: 'Zegary światowe',
    quickActions: 'Szybkie akcje',
    actions: {
      visa: 'Śledzenie wiz',
      cost: 'Porównanie kosztów',
      timezone: 'Strefy czasowe',
      tax: 'Asystent podatkowy',
      guide: 'Przewodnik miast',
    },
    recentActivity: 'Ostatnia aktywność',
    noActivity: 'Brak ostatniej aktywności',
  },
  visa: {
    title: 'Zarządzanie wizami',
    subtitle: 'Śledź i zarządzaj informacjami o wizach',
    searchPlaceholder: 'Szukaj kraju...',
    allRegions: 'Wszystkie regiony',
    regions: {
      europe: 'Europa',
      asia: 'Azja',
      americas: 'Ameryki',
      oceania: 'Oceania',
    },
    noCountries: 'Nie znaleziono krajów',
    requirements: 'Wymagania',
    documents: 'Wymagane dokumenty',
    track: 'Śledź tę wizę',
    applyUrl: 'Link do wniosku',
    myTracked: 'Moje śledzone wizy',
  },
  cost: {
    title: 'Koszty życia',
    subtitle: 'Porównuj koszty życia w różnych miastach',
    selectCities: 'Wybierz miasta',
    selectHint: 'Wybierz 2-4 miasta do porównania',
    compare: 'Porównaj',
    selectedCount: 'Wybrano {count} miast',
    comparison: 'Porównanie',
    category: 'Kategoria',
    nomadScore: 'Ocena nomady',
    budgetFinder: 'Wyszukiwarka budżetu',
    budgetPlaceholder: 'Wprowadź miesięczny budżet',
    findCities: 'Znajdź miasta',
    aiSuggestion: 'Sugestie AI wkrótce',
  },
  timezone: {
    title: 'Zarządzanie strefami czasowymi',
    subtitle: 'Zarządzaj harmonogramami i spotkaniami w wielu strefach',
    addTimezone: 'Dodaj strefę czasową',
    noTimezones: 'Kliknij powyżej, aby dodać strefy czasowe',
    meetingScheduler: 'Planowanie spotkań',
    meetingHint: 'Wybierz strefy czasowe uczestników, aby znaleźć najlepszy czas',
    findMeeting: 'Znajdź czas spotkania',
    finding: 'Wyszukiwanie...',
    bestTime: 'Najlepszy czas',
    workingOverlap: 'Nakładka godzin pracy',
  },
  tax: {
    title: 'Asystent podatkowy',
    subtitle: 'Transgraniczne obliczenia podatkowe i zgodność',
    rules: 'Przepisy podatkowe',
    selectCountry: 'Wybierz kraj',
    thresholdDays: 'Próg dni pobytu',
    days: 'dni',
    taxRates: 'Stawki podatkowe',
    reportingRequirements: 'Obowiązki sprawozdawcze',
    importantDates: 'Ważne daty',
    residenceTracker: 'Śledzenie dni pobytu',
    noResidenceDays: 'Brak zarejestrowanych dni pobytu',
    riskIndicator: 'Wskaźnik ryzyka podatkowego',
    noRiskData: 'Brak dostępnych danych o ryzyku',
    countries: {
      portugal: 'Portugalia',
      thailand: 'Tajlandia',
      spain: 'Hiszpania',
      germany: 'Niemcy',
      estonia: 'Estonia',
      georgia: 'Gruzja',
      croatia: 'Chorwacja',
      mexico: 'Meksyk',
      colombia: 'Kolumbia',
      indonesia: 'Indonezja',
      japan: 'Japonia',
      southKorea: 'Korea Południowa',
      unitedKingdom: 'Wielka Brytania',
      unitedStates: 'Stany Zjednoczone',
    },
  },
  guide: {
    title: 'Przewodnik miast',
    subtitle: 'Przewodniki po światowych destynacjach dla cyfrowych nomadów',
    allContinents: 'Wszystkie',
    noCities: 'Nie znaleziono miast',
    backToList: 'Powrót do listy',
    internetQuality: 'Jakość Internetu',
    safetyRating: 'Ocena bezpieczeństwa',
    climate: 'Klimat',
    communitySize: 'Wielkość społeczności',
    coworkingSpaces: 'Coworkingi',
    noCoworking: 'Brak dostępnych coworkingów',
    day: 'dzień',
  },
  settings: {
    title: 'Ustawienia',
    subtitle: 'Zarządzaj kontem i preferencjami',
    profile: 'Profil',
    username: 'Nazwa użytkownika',
    email: 'E-mail',
    saveProfile: 'Zapisz profil',
    saving: 'Zapisywanie...',
    language: 'Język',
    notifications: 'Powiadomienia',
    visaExpiryNotif: 'Przypomnienia o wygaśnięciu wiz',
    taxReminderNotif: 'Przypomnienia podatkowe',
    appearance: 'Wygląd',
    light: 'Jasny',
    dark: 'Ciemny',
    baseTimezone: 'Podstawowa strefa czasowa',
    dangerZone: 'Strefa niebezpieczna',
    dangerDesc: 'Te działania są nieodwracalne, postępuj ostrożnie',
    deleteAccount: 'Usuń konto',
    confirmDelete: 'Potwierdź usunięcie konta',
    confirmDeleteDesc: 'To trwale usunie Twoje konto i wszystkie dane. Tej operacji nie można cofnąć.',
    cancel: 'Anuluj',
    confirm: 'Usuń',
  },
  about: {
    title: 'O nas',
    subtitle: 'NomadMate - Asystent cyfrowego nomady',
    version: 'Wersja',
    versionNumber: '1.0.0',
    description: 'NomadMate to asystent zaprojektowany dla cyfrowych nomadów, oferujący zarządzanie wizami, porównanie kosztów życia, zarządzanie strefami czasowymi, obliczenia podatkowe i przewodniki miast, ułatwiający globalne życie nomady.',
    openSource: 'Podziękowania open source',
    openSourceDesc: 'Ten projekt jest zbudowany na następujących doskonałych projektach open source',
    contact: 'Skontaktuj się',
    support: 'Wsparcie techniczne',
    feedback: 'Opinie',
    privacyPolicy: 'Polityka prywatności',
    terms: 'Regulamin usługi',
  },
}
